import { FEATURE_FLAGS_FROM_STATE } from 'yeself-common/typings/FeatureFlags';

import { FeatureFlagsActionTypes, FEATURE_FLAGS_SET_FLAGS } from './FeatureFlagsAction';

import { featureFlagsInitialState } from './FeatureFlagsService';

const initialState: typeof FEATURE_FLAGS_FROM_STATE = featureFlagsInitialState();

const FeatureFlagsReducer = (
    state: typeof FEATURE_FLAGS_FROM_STATE = initialState,
    action: FeatureFlagsActionTypes
): typeof FEATURE_FLAGS_FROM_STATE => {
    switch (action.type) {
        case FEATURE_FLAGS_SET_FLAGS:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default FeatureFlagsReducer;
